import { DrillIcon } from "./icon";
import { type Drill, dateLabel } from "./types";

export function MasteryProgress({
  drill,
  compact = false,
}: {
  drill: Drill;
  compact?: boolean;
}) {
  const { completedCount, targetCount, mastered, nextReviewOn } = drill.mastery;
  return (
    <div
      className={`drill-mastery${compact ? " compact" : ""}${mastered ? " mastered" : ""}`}
    >
      <div className="drill-mastery-heading">
        <span className="drill-kicker">
          <DrillIcon name={mastered ? "check" : "target"} size={16} />
          {mastered ? "マスター" : compact ? "マスターまで" : "習得の進捗"}
        </span>
        <strong>
          {Math.min(completedCount, targetCount)}
          <small> / {targetCount}回達成</small>
        </strong>
      </div>
      <progress
        aria-label="マスターまでの達成回数"
        value={Math.min(completedCount, targetCount)}
        max={targetCount}
      />
      <p>
        {mastered ? (
          "目標の達成回数に到達しました。"
        ) : completedCount === 0 ? (
          "初回は今日から取り組めます。"
        ) : nextReviewOn ? (
          <>
            次の目安：
            <time dateTime={nextReviewOn}>{dateLabel(nextReviewOn)}</time>
          </>
        ) : null}
      </p>
      {!compact && (
        <details className="drill-mastery-plan">
          <summary>
            全{targetCount}回の取り組み間隔
            {completedCount > targetCount
              ? ` · 累計${completedCount}回達成`
              : ""}
          </summary>
          <ol>
            {drill.collection.masteryPlan.intervalsDays.map((days, index) => (
              <li
                // biome-ignore lint/suspicious/noArrayIndexKey: milestone identity is its fixed ordinal.
                key={index}
                className={index < completedCount ? "achieved" : ""}
              >
                <span>
                  {index < completedCount ? (
                    <DrillIcon name="check" size={14} />
                  ) : (
                    <span className="drill-milestone-dot" />
                  )}{" "}
                  {index + 1}回目
                </span>
                <span>{index === 0 ? "当日" : `前回達成から${days}日後`}</span>
              </li>
            ))}
          </ol>
          <small>予定より早い達成も回数に含まれます。</small>
        </details>
      )}
    </div>
  );
}
